module.exports = __webpack_public_path__ + "img/box_cng_grey.eea7aa62.png";